import api from './api'

export interface ShiftAssignment { id: number; shiftId: number; userId: string; status: string }
export interface Shift { id: number; name: string; startsAt: string; endsAt: string }
export interface TimeClockEntry { id: number; clockInAt: string; clockOutAt?: string }
export interface AttendanceSummary { userId: string; entries: number; totalMinutes: number }

export const schedulingService = {
    createShift: async (req: { name: string; startsAt: string; endsAt: string; routeId?: number; userIds?: string[] }): Promise<Shift> =>
        (await api.post<Shift>('/api/v1/scheduling/shifts', req)).data,
    assignments: async (shiftId: number): Promise<ShiftAssignment[]> =>
        (await api.get<ShiftAssignment[]>(`/api/v1/scheduling/shifts/${shiftId}/assignments`)).data,
    confirm: async (assignmentId: number): Promise<ShiftAssignment> =>
        (await api.post<ShiftAssignment>(`/api/v1/scheduling/assignments/${assignmentId}/confirm`)).data,
    clockIn: async (req?: { shiftId?: number; lat?: number; lon?: number }): Promise<TimeClockEntry> =>
        (await api.post<TimeClockEntry>('/api/v1/scheduling/clock-in', req || {})).data,
    clockOut: async (req?: { lat?: number; lon?: number }): Promise<TimeClockEntry> =>
        (await api.post<TimeClockEntry>('/api/v1/scheduling/clock-out', req || {})).data,
    myAttendance: async (): Promise<AttendanceSummary> =>
        (await api.get<AttendanceSummary>('/api/v1/scheduling/attendance/me')).data,
}
